import { defineComponent, ref, computed, openBlock, createElementBlock, createElementVNode, Fragment, renderList, createBlock, unref, normalizeClass, withCtx, toDisplayString } from "vue";
import { CdrButton, IconStarStroke, IconStar100 } from "@rei/cedar";
const _hoisted_1 = {
  class: "review-this"
};
const _hoisted_2 = {
  class: "review-this__stars-container"
};
const _hoisted_3 = ["data-ui", "onMouseenter"];
const _hoisted_4 = {
  class: "pdp-sr-only"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsReviewThis",
  props: {
    userStars: {},
    hasReviews: {
      type: Boolean
    }
  },
  emits: ["reviewStarClick", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const starsHovered = ref(0);
    const slugText = computed(() => props.hasReviews ? "Adding a review will require a valid email for verification" : "Be the first to review this product");
    const displayRating = computed(() => starsHovered.value || props.userStars);
    const handleMouseOver = (index) => {
      starsHovered.value = index + 1;
    };
    const handleMouseLeave = () => {
      starsHovered.value = 0;
    };
    const reviewStarClickHandler = (value) => {
      emit("metricsClick", {
        linkName: "reviews_review"
      });
      emit("reviewStarClick", value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [(openBlock(), createElementBlock(Fragment, null, renderList(5, (button, index) => {
        return createElementVNode("div", {
          key: index,
          "data-ui": `review-star-${index}`,
          class: "review-this__star-wrapper",
          onMouseenter: ($event) => handleMouseOver(index),
          onMouseleave: _cache[1] || (_cache[1] = ($event) => handleMouseLeave())
        }, [(openBlock(), createBlock(unref(CdrButton), {
          key: index,
          "icon-only": true,
          class: normalizeClass(["review-this__star", {
            "review-this__star--hovered": displayRating.value > index
          }]),
          onClick: ($event) => reviewStarClickHandler(index + 1),
          onFocus: ($event) => handleMouseOver(index),
          onBlur: _cache[0] || (_cache[0] = ($event) => handleMouseLeave())
        }, {
          icon: withCtx(() => [displayRating.value <= index ? (openBlock(), createBlock(unref(IconStarStroke), {
            key: 0,
            "inherit-color": true,
            class: "review-this__star-icon"
          })) : (openBlock(), createBlock(unref(IconStar100), {
            key: 1,
            class: "review-this__star-icon--hover"
          }))]),
          default: withCtx(() => [createElementVNode("span", _hoisted_4, "rate this product " + toDisplayString(index + 1) + " stars", 1)]),
          _: 2
        }, 1032, ["class", "onClick", "onFocus"]))], 40, _hoisted_3);
      }), 64))]), createElementVNode("p", null, toDisplayString(slugText.value), 1)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsReviewThis2.mjs.map
